module.exports = __webpack_public_path__ + "img/fire.1e2eecd6.svg";